import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav className={`fixed w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-omnio-black/80 backdrop-blur-md border-b border-omnio-charcoal' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex-shrink-0 flex items-center">
            <span className="text-omnio-white font-bold text-2xl tracking-widest uppercase">OMNIO</span>
          </div>
          <div className="hidden md:flex items-center space-x-8">
            <a href="#features" className="text-omnio-silver hover:text-omnio-white transition-colors text-sm uppercase tracking-wide">Features</a>
            {/* <a href="#system" className="text-omnio-silver hover:text-omnio-white transition-colors text-sm uppercase tracking-wide">The System</a> */}
            <a href="#contact" className="text-omnio-silver hover:text-omnio-white transition-colors text-sm uppercase tracking-wide">Contact</a>
            {/* <button className="bg-omnio-white text-omnio-black px-6 py-2 rounded-full font-medium text-sm hover:bg-omnio-silver transition-colors">
              Get Early Access
            </button> */}
          </div>
          <div className="md:hidden flex items-center">
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="text-omnio-silver hover:text-omnio-white focus:outline-none"
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-omnio-black border-b border-omnio-charcoal">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
            <a href="#features" className="block px-3 py-2 text-base font-medium text-omnio-silver hover:text-omnio-white" onClick={() => setMobileMenuOpen(false)}>Features</a>
            {/* <a href="#system" className="block px-3 py-2 text-base font-medium text-omnio-silver hover:text-omnio-white" onClick={() => setMobileMenuOpen(false)}>The System</a> */}
            <a href="#contact" className="block px-3 py-2 text-base font-medium text-omnio-silver hover:text-omnio-white" onClick={() => setMobileMenuOpen(false)}>Contact</a>
            {/* <button className="w-full text-left px-3 py-2 text-base font-medium text-omnio-black bg-omnio-white rounded-md mt-4" onClick={() => setMobileMenuOpen(false)}>
              Get Early Access
            </button> */}
          </div>
        </div>
      )}
    </nav>
  );
}
